const state = {
  userId: '',
  userToken: '',
  isVip: null,
}

const actions = {

}

const mutations = {
  setUserInfo(state, param) {
    const { userId, userToken, isVip } = param;
    state.userId = userId;
    state.userToken = userToken;
    state.isVip = isVip;
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/user.js